import React from 'react';
import { Program } from '@playbook-technologies/common-enums';
import { MenuItem, TextField } from '@mui/material';
import { isInteger } from 'lodash';

type collectionType = number;

const submit = (type: collectionType, disabled: boolean, onChange) => {
  if (disabled) {
    return;
  }

  if (!confirm('Are you sure you want to change the collection type?')) {
    return;
  }

  return onChange(type);
};

export const CollectionType = ({
  disabled,
  type,
  onChange,
}: {
  disabled: boolean;
  type: number;
  onChange: (type: number) => void;
}) => (
  <TextField
    className="min-w-[150px]"
    disabled={disabled}
    fullWidth
    label="Type"
    name="type"
    onChange={(e) => {
      const selection = parseInt(e.target.value);

      if (!isInteger(selection)) {
        return;
      }

      submit(selection, disabled, onChange);
    }}
    select
    value={type}
  >
    <MenuItem value={Program.Type.Collection.value}>Category</MenuItem>
    <MenuItem value={Program.Type.Program.value}>Program</MenuItem>
  </TextField>
);
